export default __webpack_public_path__ + "static/media/chugaku.ac421ed7.jpg";